if (!customElements.get('mango-album')) {
  customElements.define('mango-album', class MangoAlbum extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.items = [...this.querySelectorAll('[data-me-album-image]')];
      if (!this.dialog || !this.items.length || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.fullImage = this.querySelector('[data-me-album-full-image]');
      this.caption = this.querySelector('[data-me-album-caption]');
      this.position = this.querySelector('[data-me-album-position]');
      this.error = this.querySelector('[data-me-album-error]');
      this.errorLink = this.querySelector('[data-me-album-error-link]');
      const previous = this.querySelector('[data-me-album-previous]');
      const next = this.querySelector('[data-me-album-next]');
      previous.hidden = this.items.length < 2;
      next.hidden = this.items.length < 2;
      this.items.forEach((item, index) => {
        item.setAttribute('aria-haspopup', 'dialog');
        item.setAttribute('aria-controls', this.dialog.id);
        item.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.returnFocus = item;
          this.showImage(index);
          this.dialog.showModal();
          document.documentElement.classList.add('me-album-is-open');
        }, options);
      });
      this.querySelector('[data-me-album-close]').addEventListener('click', () => this.dialog.close(), options);
      previous.addEventListener('click', () => this.showImage(this.currentIndex - 1), options);
      next.addEventListener('click', () => this.showImage(this.currentIndex + 1), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'Tab') {
          const controls = [...this.dialog.querySelectorAll('button:not([disabled]), a[href]')].filter(element => element.getClientRects().length > 0);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
          }
          return;
        }
        const destinations = { ArrowLeft: this.currentIndex - 1, ArrowRight: this.currentIndex + 1, Home: 0, End: this.items.length - 1 };
        if (!(event.key in destinations)) return;
        event.preventDefault();
        this.showImage(destinations[event.key]);
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('me-album-is-open');
        this.returnFocus?.focus({ preventScroll: true });
      }, options);
      this.fullImage.addEventListener('error', () => {
        this.fullImage.hidden = true;
        this.error.hidden = false;
      }, options);
    }

    showImage(index) {
      this.currentIndex = (index + this.items.length) % this.items.length;
      const item = this.items[this.currentIndex];
      this.error.hidden = true;
      this.errorLink.href = item.href;
      this.fullImage.alt = item.dataset.imageAlt || '';
      this.fullImage.width = Number(item.dataset.imageWidth) || 1;
      this.fullImage.height = Number(item.dataset.imageHeight) || 1;
      this.fullImage.src = item.href;
      this.fullImage.hidden = false;
      this.caption.textContent = item.dataset.imageCaption || '';
      this.position.textContent = this.dataset.counterTemplate.replace('[position]', this.currentIndex + 1).replace('[count]', this.items.length);
    }

    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.classList.remove('me-album-is-open');
      }
      this.controller?.abort();
    }
  });
}
